module.exports = __webpack_public_path__ + "static/media/GT-Alpina-Regular-Italic.7c2380ce.woff";